// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"pi"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9.36238 4.525C9.08389 9.60399 7.48612 18.5638 3 19.4479M4.16129 4H20.4194M21 18.3036C18.6774 20.5922 16.0186 20.3411 14.9032 18.8757C14.0629 17.7717 14.3937 9.21192 14.8525 4.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PiIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pi',
    ref,
    icon: element,
  },
));

PiIcon.displayName = 'PiIcon';

export default PiIcon;
